import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@rebass/grid';
import { isMobile } from 'app/helpers/utils';

const Text = styled.div.attrs({
  tabIndex: 0,
})`
  font-weight: 700;
  font-size: ${({ size }) => size}px;
  line-height: ${({ lineHeight }) => lineHeight};
  //text-transform: lowercase;
  color: #f49f61;
  cursor: pointer;
  ${isMobile && `text-align: center;`};
`;

const Logo = ({ width, text, ...rest }) => (
  <Box width={width} py={[2, 2, 0]}>
    <Text
      onClick={e =>
        (window.location = `${window.location.origin}${
          window.location.pathname
        }`)
      }
      {...rest}
    >
      {text}
    </Text>
  </Box>
);

Logo.defaultProps = {
  size: isMobile ? 21 : 23,
  lineHeight: isMobile ? 'normal' : '21px',
  text: 'The Restaurant Website Report',
};

Logo.propTypes = {
  width: PropTypes.array.isRequired,
  size: PropTypes.number.isRequired,
  lineHeight: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default Logo;
